// TODO perf might be better if you follow the advice here (not really read it though): https://stackoverflow.com/questions/48816441/how-to-use-requestanimationframe-inside-a-class-object

(function () {
    'use strict';

    const animConts = document.querySelectorAll('.js-introanimcrosses');

    /**
     * Cross object
     */
    function Cross(elm) {
        this.elm = elm,
            this.animTime = 2000,
            this.animComplete = false,
            this.deltaTime = 0,
            this.startTime = false,
            this.timestampLastFrame = 0,
            this.pos = {
                x: 0,
                y: 0,
            },
            this.startPos = {
                x: 0,
                y: 0,
            },
            this.targetPos = {
                x: 200,
                y: 100,
            },
            this.distance = {
                x: 0,
                y: 0,
            },
            this.angleSin = -(Math.PI / 2),
            this.angleSinInc = (Math.PI) / this.animTime,

            this.move = function (timestamp) {
                if (timestamp) {
                    if (!this.startTime) {
                        this.startTime = timestamp;
                    }

                    if (this.timestampLastFrame > 0) {
                        this.deltaTime = timestamp - this.timestampLastFrame;
                    }

                    this.angleSin += this.angleSinInc * this.deltaTime;

                    let distanceXNow = this.distance.x * Math.sin(this.angleSin) + this.distance.x;
                    let distanceYNow = this.distance.y * Math.sin(this.angleSin) + this.distance.y;

                    this.setPos(this.startPos.x + distanceXNow, this.startPos.y + distanceYNow);

                    this.timestampLastFrame = timestamp;
                }

                if (timestamp >= this.startTime + this.animTime) {
                    // if it goes over the time, set pos to targetPos (to avoid it going over by one frame or half a frame, or whatever)
                    this.setPos(this.targetPos.x, this.targetPos.y);
                    this.setStartPos(this.targetPos.x, this.targetPos.y);
                    this.setTargetPos(this.targetPos.x, this.targetPos.y);
                    this.animComplete = true;
                    cancelAnimationFrame(this.move.bind(this));
                } else {
                    requestAnimationFrame(this.move.bind(this));
                }
            },


            this.setPos = function (x, y) {
                this.pos = {
                    x: x,
                    y: y,
                }
                // midhandled
                this.elm.style.transform = `translateX(${x - (this.elm.clientWidth / 2)}px) translateY(${y - (this.elm.clientHeight / 2)}px)`;
            },
            this.setStartPos = function (x, y) {
                this.startPos = {
                    x: x,
                    y: y,
                }
            },
            this.setTargetPos = function (x, y) {
                this.targetPos = {
                    x: x,
                    y: y,
                }
            }
            this.setDistance = function () {
                this.distance = {
                    x: (this.targetPos.x - this.startPos.x) / 2,
                    y: (this.targetPos.y - this.startPos.y) / 2,
                }
            }
    }


    /**
     * Set initial positions for all crosses
     */
    function initialPositions(crosses, animCont) {
        if (crosses.length === 3) {
            const contWidth = animCont.clientWidth;
            const contHeight = animCont.clientHeight;
            crosses[0].setPos(contWidth * .17, contHeight * .57);
            crosses[1].setPos(contWidth * .57, contHeight * .98);
            crosses[2].setPos(contWidth * .81, contHeight * .25);
            crosses[0].setStartPos(contWidth * .17, contHeight * .57);
            crosses[1].setStartPos(contWidth * .57, contHeight * .98);
            crosses[2].setStartPos(contWidth * .81, contHeight * .25);
        }
    }


    /**
     * Set initial targets for all crosses
     */
    function initialTargets(crosses, animCont) {
        if (crosses.length === 3) {
            const contWidth = animCont.clientWidth;
            const contHeight = animCont.clientHeight;
            const xPos1 = .5;
            const yPos1 = .75;
            const crossWidth = crosses[0].elm.clientWidth;
            const legWidth = crossWidth / 3;

            // black one
            crosses[1].setTargetPos(contWidth * xPos1, contHeight * yPos1);
            crosses[1].setDistance();

            // blue one
            crosses[0].setTargetPos(contWidth * xPos1 + crossWidth - legWidth, contHeight * yPos1 - legWidth);
            crosses[0].setDistance();

            // green one
            crosses[2].setTargetPos(contWidth * xPos1 - crossWidth + legWidth, contHeight * yPos1 + legWidth);
            crosses[2].setDistance();
        }
    }


    /**
     * Set an IntersectionObserver to watch each element.
     * This just sets an "is visible" boolean which is used by the scroll events, one of which is assigned per element.
     * TODO this is more or less the same as in introAnimSquares.js so consider making this more reusable (for when setting up observer plus scroll event)?
     */
    function observer() {
        const observerOptions = {
            rootMargin: '0px 0px 0px 0px',
            threshold: 0
        }

        var observerAnim = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio !== 0) {
                    entry.target.sfl_isVisible = true;
                } else {
                    entry.target.sfl_isVisible = false;
                }
            });
        }, observerOptions);

        //
        animConts.forEach(function (elm) {
            // store the event listener on the element itself, so we've got a reference to it to remove it later.
            // pass in a reference to the elm itself too.
            elm.sfl_scrollListener = animEventListener.bind(null, elm);
            window.addEventListener('scroll', elm.sfl_scrollListener);
            observerAnim.observe(elm);
        });
    }


    function animEventListener(elm) {
        calc(elm);
    }


    /**
     * Check if sufficiently in view, if so make elms animate
     */
    function calc(elm) {
        if (elm.sfl_isVisible) {
            // work out all the stuff
            const rect = elm.getBoundingClientRect();

            if (rect.top < window.innerHeight / 2) {
                elm.crosses.forEach(function (cross) {
                    cross.move();
                    window.removeEventListener('scroll', elm.sfl_scrollListener);
                });
            }
        }
    }


    /**
     * Resize
     */
    window.addEventListener('resize', function() {
        animConts.forEach(function (elm) {
            if (elm.crosses[0].animComplete) {
                initialTargets(elm.crosses, elm);
                elm.crosses.forEach(function(cross) {
                    cross.setPos(cross.targetPos.x, cross.targetPos.y);
                });
            } else {
                initialPositions(elm.crosses, elm);
                initialTargets(elm.crosses, elm);
            }
        });
    });


    /**
     * Main
     */

    animConts.forEach(function (elm) {
        const crossElms = elm.querySelectorAll('.js-introanimcrosses-cross');
        elm.crosses = [];

        crossElms.forEach(function (elm2) {
            const cross = new Cross(elm2);
            elm.crosses.push(cross);
        });

        initialPositions(elm.crosses, elm);
        initialTargets(elm.crosses, elm);
    });

    observer();
})();